/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';
import DeleteForever from '@material-ui/icons/DeleteForever';

// local imports
import { CampaignService } from 'app/services';
import useDataApi from '../../use-data-api';
import { FormatUtils, TableUtils } from 'app/utils';
import { IconButton, Tooltip } from '@material-ui/core';

const useCampaignsPharmaciesService = (queries, isFilteringRef, handleDeletePharmacy) => {
  const [service, setService] = useDataApi();

  // delete pharmacy
  const deletePharmacyBtn = (campaignId, pharmacyId) => {
    const tooltipTitle = 'Eczaneyi kampanyadan çıkar';

    return (
      <>
        <Tooltip arrow title={tooltipTitle} placement="top">
          <IconButton onClick={() => handleDeletePharmacy(campaignId, pharmacyId)}>
            <DeleteForever color="error" />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  const fetchData = useCallback(async () => {
    const campaignPharmaciesList = await CampaignService.getCampaignPharmacyList(queries);
    const campaignPharmacies = campaignPharmaciesList.data.data;

    const out = campaignPharmacies?.map(item => {
      const { id, status, created_at, city, district, pharmacy } = item;

      return {
        id,
        city_id: city.name,
        district_id: district.name,
        pharmacy_name: pharmacy.name,
        created_at: FormatUtils.convertDateString(created_at),
        delete_btn: deletePharmacyBtn(queries?.campaign_id, pharmacy.id)
      };
    });

    isFilteringRef.current = false;

    return {
      table: {
        columns: TableUtils.campaignPharmaciesList,
        rows: out
      },
      totalCount: campaignPharmaciesList?.data?.total_count,
      total: Math.round(campaignPharmaciesList?.data?.total_count / parseInt(queries.limit))
    };
  }, [queries]);

  useEffect(() => setService(() => fetchData()), [setService, fetchData]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useCampaignsPharmaciesService;
